import React from "react";
import { useSalon } from "../../context/SalonContext";
import { Employee } from "../../types/salon";
import { BusinessInfo } from "../../types/context";
import { TimeTrackingState, TimesheetData } from "../../types/timeTracking";
import ManagerOverviewView from "./ManagerOverviewView";
import EmployeeOverviewView from "./EmployeeOverviewView";

interface SalonContextValue {
  currentUser: Employee | null;
  businessInfo: BusinessInfo | null;
  employees: Employee[];
  isLoading: boolean;
}

type EmployeeStatusMap = Map<string, TimeTrackingState>;

interface PayrollOverviewTabProps {
  employeeStatuses: EmployeeStatusMap;
  isLoadingStatuses: boolean;
  eligibleEmployees: Employee[];
  timesheetData: TimesheetData;
  onTimesheetRefresh: () => Promise<TimesheetData>;
}

export default function PayrollOverviewTab({
  employeeStatuses,
  isLoadingStatuses,
  eligibleEmployees,
  timesheetData,
  onTimesheetRefresh,
}: PayrollOverviewTabProps) {
  const salonContext = useSalon() as unknown as SalonContextValue;
  const { currentUser } = salonContext;

  const isOwnerOrManager =
    currentUser?.role === "Owner" || currentUser?.role === "Manager";

  // Render role-specific view
  if (isOwnerOrManager) {
    return (
      <ManagerOverviewView
        employeeStatuses={employeeStatuses}
        isLoadingStatuses={isLoadingStatuses}
        eligibleEmployees={eligibleEmployees}
        timesheetData={timesheetData}
        onTimesheetRefresh={onTimesheetRefresh}
      />
    );
  }

  return <EmployeeOverviewView />;
}
